import { useState } from 'react';
import { Tabs, Tab, Box } from '@mui/material';
import CommunicationPage from '../components/tabs/communicationtTabs/ComunicationsPage';
import CommunicationReceivedPage from '../components/tabs/communicationtTabs/CommunicationReceivedPage';

function DashboardTabs() {
  const [value, setValue] = useState(0);

  const handleChange = (_event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Tabs
        value={value}
        onChange={handleChange}
        aria-label="dashboard tabs"
        sx={{ mb: 2 }}
      >
        <Tab label="Despachadas" />
        <Tab label="Recibidas" />
      </Tabs>

      {/* Panel para Comunicaciones */}
      {value === 0 && (
        <Box>
          <CommunicationPage />
        </Box>
      )}

      {/* Panel para Otra sección */}
      {value === 1 && (
        <Box>
         <CommunicationReceivedPage />
        </Box>
      )}
    </Box>
  );
}

export default DashboardTabs;
